import { extendTheme } from '@chakra-ui/react';
import { getThemeExtension } from './theme-extension';

declare const appConfig: any;

export function getBaseTheme() {
    return extendTheme(
        {
            config: {
                initialColorMode: 'light',
            },
            colors: {
                sider: {
                    background: appConfig.theme?.sidebar?.background || '#1d2327',
                    collapseButton: appConfig.theme?.sidebar?.collapseButton || '#1d2327',
                },
            },
            components: {
                Checkbox: {
                    baseStyle: {
                        control: {
                            borderColor: 'gray.400',
                        },
                    },
                }
            },
            styles: {
                global: {
                    '.editor-paragraph': {
                        marginBottom: '1em',
                    },
                    '.editor-text-bold': {
                        fontWeight: 'bold',
                    },
                    '.editor-text-italic': {
                        fontStyle: 'italic',
                    },
                    '.editor-text-underline': {
                        textDecoration: 'underline',
                    },
                }
            },
        },
        getThemeExtension()
    );
}
